import { render, staticRenderFns } from "./ss-no-data.vue?vue&type=template&id=bd815a68&"
import script from "./ss-no-data.vue?vue&type=script&lang=js&"
export * from "./ss-no-data.vue?vue&type=script&lang=js&"
import style0 from "./ss-no-data.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports